export default __webpack_public_path__ + "static/media/520.d977976a.svg";